import { db } from '../firebaseInit'
import _ from 'lodash'

export default {
  state: {
    // summaryData: [],
    tasksOnReport: []
  },
  mutations: {
    // updateSummaryTask (state, payload) {
    //   state.summaryData[payload.projectIndex].tasks[payload.taskIndex] = payload.task
    // },
    // updateSummaryProject (state, payload) {
    //   state.summaryData[payload.index] = payload.project
    //   console.log('state update success')
    // },
    getTaskOnReport (state, payload) {
      state.tasksOnReport = payload
    }
    // getSummaryData (state, payload) {
    //   state.summaryData = payload
    // }
  },
  actions: {
    // updateSummaryTask ({commit, state}, payload) { // Pass Payload - projectId: {{projectId}, task: task}
    //   const projectIndex = state.summaryData.findIndex(i => i.id === payload.projectId)
    //   console.log('Project Index', projectIndex)
    //   const taskIndex = state.summaryData[projectIndex].tasks.findIndex(i => i.id === payload.task.id)
    //   console.log('updateSummaryTask Payload', payload)
    //   console.log('Project Index', projectIndex)
    //   let dbTasks = null
    //   db.collection('summaryProject').doc(payload.projectId).get().then((response) => {
    //     dbTasks = response.data().tasks
    //     const dbTaskIndex = dbTasks.findIndex(i => i.id === payload.task.id)
    //     dbTasks[dbTaskIndex] = payload.task
    //     const newPayload = {projectIndex: projectIndex, taskIndex: taskIndex, task: payload.task}
    //     console.log('New Payload', newPayload)
    //     db.collection('summaryProject').doc(payload.projectId).update({tasks: dbTasks}).then(() => {
    //       commit('updateSummaryTask', newPayload)
    //     })
    //     .catch(error => console.log('Can not wite to database: Error: ', error))
    //   })
    // },
    // updateSummaryProject ({commit, state}, payload) { // Pass Payload - project: {{project}}
    //   console.log('Incoming Payload', payload)
    //   const stateIndex = state.summaryData.findIndex(i => i.name === payload.project.name)
    //   const newPayload = {project: payload.project, index: stateIndex}
    //   console.log('newPayload', newPayload)
    //   db.collection('summaryProject').doc(payload.project.id).update({active: false}).then(() => {
    //     console.log('update successful')
    //     commit('updateSummaryProject', newPayload)
    //   })
    //   .catch(error => console.log('Could not write data to database. Error: ', error))
    // },
    getTaskOnReport ({commit, state}, payload) {
      let taskList = []
      db.collection('settings').doc('task_templates').collection(payload).where('showTaskOnReport', '==', true).get()
      .then(query => {
        query.forEach(task => {
          taskList.push(task.data())
        })
      })
      .catch(error => console.log('Error getting task headers from database. Error: ', error))
      .then(() => {
        taskList = _.orderBy(taskList, [parseInt('days_due'), parseInt('order')])
        taskList = taskList.map(m => m.name)
        commit('getTaskOnReport', taskList)
      })
      .catch(error => console.log('Error getting task headers from database. Error: ', error))
    }
    // getSummaryData ({commit}, payload) { // Payload: status: Project Status, completed: true/false
    //   let summaryData = []
    //   db.collection('summaryProject').where('deleted', '==', false).where('status', '==', payload.status).get().then(response => {
    //     response.forEach(project => {
    //       summaryData.push({...project.data(), id: project.id})
    //     })
    //   })
    //   .then(() => {
    //     commit('getSummaryData', summaryData)
    //   })
    // }
  },
  getters: {
    tasksOnReport (state) {
      return state.tasksOnReport
    }
    // summaryData (state) {
    //   return state.summaryData
    // }
  }
}



// WEBPACK FOOTER //
// ./src/store/reports.js